import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustIndicators = [
    {
      icon: 'Shield',
      title: 'Bank-level Security',
      description: '256-bit SSL encryption protects your data'
    },
    {
      icon: 'Users',
      title: '50,000+ Users',
      description: 'Trusted by professionals worldwide'
    },
    {
      icon: 'Zap',
      title: '99.9% Uptime',
      description: 'Reliable platform you can count on'
    },
    {
      icon: 'Award',
      title: 'GDPR Compliant',
      description: 'Your privacy is our priority'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mt-6 md:mt-8 lg:mt-10">
      {trustIndicators?.map((indicator, index) => (
        <div
          key={index}
          className="flex items-start gap-3 p-4 rounded-lg bg-muted/50 border border-border/50"
        >
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={indicator?.icon} size={20} className="text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="caption font-semibold text-foreground mb-1">
              {indicator?.title}
            </h4>
            <p className="text-xs text-muted-foreground">
              {indicator?.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustSignals;